export const FETCH_COUNTRYSETTINGS_REQUEST = "FETCH_COUNTRYSETTINGS_REQUEST";
export const FETCH_COUNTRYSETTINGS_SUCCESS = "FETCH_COUNTRYSETTINGS_SUCCESS";
export const FETCH_COUNTRYSETTINGS_ERROR = "FETCH_COUNTRYSETTINGS_ERROR";
